import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { makeGetRequest } from '../services/httpHelper';

const TextSermonDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sermon, setSermon] = useState(null);
  const [others, setOthers] = useState([]);

  useEffect(() => {
    (async () => {
      const church = JSON.parse(localStorage.getItem('church'));
      const res = await makeGetRequest(`text-sermons/${church.id}`);
      if (res?.data) {
        const found = res.data.find((s) => s.id === id);
        setSermon(found);
        setOthers(res.data.filter((s) => s.id !== id));
      }
    })();
  }, [id]);

  return (
    <div className="container my-5">
      {sermon && (
        <>
          <h2>{sermon.title}</h2>
          <p><strong>{sermon.speaker}</strong> | {new Date(sermon.date).toLocaleDateString()}</p>
          <div dangerouslySetInnerHTML={{ __html: sermon.body }} />
        </>
      )}

      <hr />
      <h4>Other Sermons</h4>
      <ul>
        {others.map((s) => (
          <li key={s.id} onClick={() => navigate(`/sermons/text/${s.id}`)} style={{ cursor: 'pointer' }}>
            {s.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TextSermonDetail;
